/**
 * @function keys
 * This function allows you to type the Object.keys function
 * @param value
 */
export default function keys<O>(value: O) {
  return Object.keys(value) as (keyof O)[]
}
